import type React from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/atoms/card";
import ScalingLogoLarge from "../icons/ScalingLogoLarge";
import { LanguageSelector } from "~/molecules/LanguageSelector";

interface Props extends Omit<React.HTMLAttributes<HTMLElement>, "title"> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
}

export const AuthLayout = ({ title, description, icon, children }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="container flex min-h-screen flex-col items-center justify-between py-6">
      <div className="flex w-full justify-between">
        <div className="max-w-50">
          <ScalingLogoLarge />
        </div>
        <LanguageSelector />
      </div>

      <Card className="w-full max-w-120 gap-8">
        <CardHeader>
          {icon}
          {title && (
            <CardTitle className="text-2xl font-semibold tracking-tight">
              {title}
            </CardTitle>
          )}
          {description && (
            <CardDescription className="text-sm leading-6">
              {description}
            </CardDescription>
          )}
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>

      <p className="text-muted-foreground text-xs">
        © {new Date().getFullYear()} {t(($) => $.commons.copyright)}
      </p>
    </div>
  );
};
